<template>
  <div>
    <v-btn
      icon
      color="primary"
      x-small
      depressed
      @click="openDialog"
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
    <v-dialog
      @keydown.esc="isOpen=false"
      v-model="isOpen"
      width="500">
      <v-card>
        <v-card-title>
          Ubicación en almacén de {{ input.name }}
        </v-card-title>
        <v-card-text>
          <v-form v-model="isValid" ref="create">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md12>
                  <v-text-field
                    v-model="form.warehouseLocation"
                    label="Nombre"
                    :rules="rules.warehouseLocation"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            outlined
            small
            depressed
            @click="closeDialog">
            {{ $t('ctas.close') }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            dark
            small
            depressed
            @click="create">
            {{ $t('ctas.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  props: {
    input: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      isValid: false,
      form: {
        warehouseLocation: null
      },
      rules: {
        warehouseLocation: [v => !!v || `La ubicación en almacén ${this.$i18n.t('messages.isRequired')}`]
      }
    }
  },
  watch: {
    isOpen (val) {
      if (val) this.form.warehouseLocation = this.input.warehouseLocation
    }
  },
  methods: {
    openDialog () {
      const vm = this
      setTimeout(() => { vm.isOpen = true })
    },
    closeDialog () {
      this.isOpen = false
      this.form = {
        warehouseLocation: null
      }
      this.$refs.create.resetValidation()
      this.$emit('close', false)
    },
    async create () {
      this.$refs.create.validate()
      if (this.isValid) {
        this.overlay = true
        const payload = { warehouseLocation: this.form.warehouseLocation }
        try {
          const input = await this.$api.put(`/v1/inputs/${this.input._id}/set`, payload)
          this.$emit('update', input)
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
        this.closeDialog()
      }
    }
  }
}
</script>
